module.exports = __webpack_public_path__ + "img/banner2.e5fac749.png";